module.exports = __webpack_public_path__ + "img/hospital.5d41c2eb.png";